// ? remove this commented code once all confirmed
// ? that all the modules this function is being used
// ? are operating properly
// Import necessary React and React Router hooks
import { useState } from "react";
// Import necessary Material-UI components
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
// Import necessary Material-UI Date utilities components
import { getGridDateOperators } from "@mui/x-data-grid";
// Import necessary Material-UI icons
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// Import custom components and utility functions
// import { RenderCellExpand, ItemDetailsDropDown } from "../";
import { activeStatusOperators, formatDate } from ".";
// Import lodash utility functions
import _ from "lodash";
import {
  CustomMUIChip,
  ItemDetailsDropDown,
  RenderCellExpand,
} from "../components";

export function CreateTableColumns({ data, detailsBool, sampleRequestID }) {
  // State to track the index of the clicked row for expanding details
  const [clickedIndex, setClickedIndex] = useState(-1);
  // Initialize an empty array to hold the column definitions
  let tableColumns = [];
  // If detailsBool is true, add a column for expanding details
  if (data) {
    detailsBool &&
      tableColumns.push({
        field: "Details",
        headerName: "Details",
        filterable: false,
        renderCell: (params) => {
          return (
            <IconButton
              onClick={() => {
                // Toggle the clickedIndex state to expand or collapse details
                clickedIndex === params.id
                  ? setClickedIndex(-1)
                  : setClickedIndex(params.id);
              }}
            >
              {/* Display different icons based on whether the row is expanded */}
              {params.id === clickedIndex ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          );
        },
        width: 60,
      });
    /////
    // Iterate over the properties of the first object in the data array
    for (let prop in data[0]) {
      if (Object.hasOwn(data[0], prop)) {
        // Exclude certain properties from being displayed as columns
        if (
          // Add more property names to exclude as needed
          prop !== "id" &&
          prop !== "_id" &&
          prop !== "needByDate" &&
          prop !== "leadTime" &&
          prop !== "date" &&
          prop !== "items" &&
          prop !== "procurementApproval" &&
          prop !== "sampleRequestStatus" &&
          prop !== "userStatus" &&
          prop !== "procurementStatus" &&
          prop !== "supplierStatus" &&
          prop !== "executiveChefStatus" &&
          prop !== "HODStatus" &&
          prop !== "noOfSamplesRequired" &&
          prop !== "dateModified" &&
          prop !== "editItem" &&
          prop !== "editOrDeleteItem" &&
          prop !== "markInactive" &&
          prop !== "sampleRequestID" &&
          prop !== "sampleItemID" &&
          prop !== "qualityReportsID" &&
          prop !== "supplierList" &&
          prop !== "HODApproval" &&
          prop !== "execChefApproval" &&
          prop !== "userApproval" &&
          prop !== "dateSupplierAdded" &&
          prop !== "productImage" &&
          prop !== "productImages" &&
          prop !== "primaryProductImages" &&
          prop !== "secondaryProductImages" &&
          prop !== "requesterSampleImage" &&
          prop !== "productionDate" &&
          prop !== "requestDate" &&
          prop !== "deliveredDate" &&
          prop !== "receiptDate" &&
          prop !== "expiryDate" &&
          prop !== "isActive"
          // prop !== "organization"
        ) {
          // Define column properties based on the property name
          // Add additional column definitions for specific properties as needed
          tableColumns.push({
            field: prop,
            headerName: _.startCase(prop),
            type: prop === "date" ? "date" : "string",
            flex: 1,
            minWidth: 180,
            align: "left",
            headerAlign: "left",
            renderCell: RenderCellExpand,
          });
        }
      }
      if (
        prop === "sampleRequestStatus" ||
        prop === "HODApproval" ||
        prop === "execChefApproval" ||
        prop === "userApproval"
      ) {
        tableColumns.push({
          field: prop,
          headerName: _.startCase(prop),
          type: "string",
          flex: 1,
          minWidth: 120,
          align: "left",
          headerAlign: "left",
          valueGetter: (params) =>
            params.value && _.startCase(params.value.status),
        });
      }
      // Procurement approval column group
      if (prop === "procurementApproval") {
        tableColumns.push(
          {
            field: "status",
            headerName: _.startCase("status"),
            type: "string",
            flex: 1,
            minWidth: 120,
            align: "left",
            headerAlign: "left",
            valueGetter: (params) =>
              params && _.startCase(params.row.procurementApproval.status),
          },
          {
            field: "processedBy",
            headerName: _.startCase("processedBy"),
            type: "string",
            flex: 1,
            minWidth: 150,
            align: "left",
            headerAlign: "left",
            valueGetter: (params) =>
              params.row.procurementApproval.processedBy
                ? params.row.procurementApproval.processedBy
                : "N/A",
          }
        );
      }
      // Renders the Item Details Dropdown on the sample request details page
      if (
        (prop === "sampleRequestID" || prop === "sampleItemID") &&
        prop !== "qualityReportsID"
      ) {
        tableColumns.push({
          field: prop,
          headerName: _.startCase(prop),
          type: "string",
          flex: 1,
          minWidth: 220,
          align: "left",
          headerAlign: "left",
          sortable: false,
          colSpan: (cellValues) => {
            return cellValues.id === clickedIndex ? 20 : 1;
          },
          renderCell: detailsBool
            ? (cellValues) => {
                return ItemDetailsDropDown(
                  cellValues,
                  clickedIndex,
                  sampleRequestID
                );
              }
            : null,
        });
      }
      if (prop === "qualityReportsID") {
        tableColumns.push({
          field: prop,
          headerName: _.startCase(prop),
          type: "string",
          flex: 1,
          minWidth: 220,
          align: "left",
          headerAlign: "left",
          sortable: false,
        });
      }
      if (prop === "leadTime") {
        tableColumns.push({
          field: prop,
          headerName: _.startCase(prop),
          type: "number",
          flex: 1,
          minWidth: 120,
          align: "left",
          headerAlign: "left",
        });
      }
      if (
        prop === "date" ||
        prop === "dateModified" ||
        prop === "needByDate" ||
        prop === "dateSupplierAdded" ||
        prop === "productionDate" ||
        prop === "receiptDate" ||
        prop === "expiryDate" ||
        prop === "requestDate" ||
        prop === "deliveredDate"
      ) {
        tableColumns.push({
          field: prop,
          headerName: _.startCase(prop),
          type: "date",
          flex: 1,
          minWidth: 120,
          align: "left",
          headerAlign: "left",
          filterOperators: _.reject(
            getGridDateOperators(),
            (operator) => operator.value === "before"
          ),
          valueFormatter: (params) =>
            params.value !== "pending"
              ? formatDate(params.value)
              : params.value,
        });
      }

      if (prop === "items") {
        tableColumns.push({
          field: prop,
          headerName: "No. of Items",
          type: "number",
          flex: 1,
          minWidth: 120,
          align: "left",
          headerAlign: "left",
          valueGetter: (params) => params.value.length,
        });
      }
      if (prop === "productImage") {
        tableColumns.push({
          field: prop,
          headerName: _.startCase(prop),
          type: "object",
          flex: 1,
          minWidth: 120,
          align: "left",
          headerAlign: "left",

          renderCell: (params) => {
            return (
              <div>
                {params.value && params.value.name
                  ? params.value.name
                  : params.value.length
                  ? params.value.length
                  : "N/A"}
              </div>
            );
          },
        });
      }

      if (
        prop === "primaryProductImages" ||
        prop === "secondaryProductImages"
      ) {
        tableColumns.push({
          field: prop,
          headerName: _.startCase(prop),
          type: "object",
          flex: 1,
          minWidth: 120,
          align: "left",
          headerAlign: "left",

          renderCell: () => {
            return <div>{console.log("abc")}</div>;
          },
        });
      }

      // retain this code block
      // this piece of coded is here
      // in case of a future use case
      // if (prop === "requesterSampleImage") {
      //   tableColumns.push({
      //     field: prop,
      //     headerName: _.startCase(prop),
      //     type: "object",
      //     flex: 1,
      //     minWidth: 120,
      //     align: "left",
      //     headerAlign: "left",
      //     renderCell: (params) => {
      //       return (
      //         <div>
      //           {params.value
      //             ? params.value.name
      //               ? params.value.name
      //               : params.value.length
      //             : "0"}
      //         </div>
      //       );
      //     },
      //   });
      // }

      if (prop === "editItem") {
        tableColumns.push({
          field: prop,
          headerName: "Edit item",
          type: "object",
          flex: 1,
          minWidth: 120,
          align: "left",
          headerAlign: "left",
          renderCell: (params) => {
            return (
              <div>
                <Button
                  variant="contained"
                  color="info"
                  size="small"
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  Edit
                </Button>
              </div>
            );
          },
        });
      }
      if (prop === "editOrDeleteItem") {
        tableColumns.push({
          field: prop,
          headerName: "Edit/Delete item",
          type: "object",
          flex: 1,
          minWidth: 120,
          align: "left",
          headerAlign: "left",
          renderCell: (params) => {
            return (
              <div>
                <Button
                  variant="contained"
                  color="info"
                  size="small"
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  Edit/Delete
                </Button>
              </div>
            );
          },
        });
      }
      if (prop === "markInactive") {
        tableColumns.push({
          field: prop,
          headerName: "Mark as Inactive",
          type: "object",
          flex: 1,
          minWidth: 160,
          align: "left",
          headerAlign: "left",
          renderCell: (params) => {
            return params.value === "Mark Inactive" ? (
              <div>
                <Button
                  variant="contained"
                  color="info"
                  size="small"
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  Mark Inactive
                </Button>
              </div>
            ) : null;
          },
        });
      }
      if (prop === "isActive") {
        tableColumns.push({
          field: prop,
          headerName: "Item Status",
          type: "string",
          flex: 1,
          minWidth: 120,
          align: "left",
          headerAlign: "left",
          filterOperators: activeStatusOperators,
          renderCell: (params) => {
            return (
              <CustomMUIChip
                label={params.value === true ? "Active" : "Inactive"}
                status={params.value}
                variant="outlined"
                color={params.value === true ? "success" : "error"}
              />
            );
          },
        });
      }
    }
    /////
    let statusArray = [];
    let rest = [];
    let actions = [];
    /////
    // Rearrange the columns so that status fields appear at the end
    tableColumns.forEach((object) => {
      if (
        // object.field === "procurementApproval" ||
        object.field === "sampleRequestStatus" ||
        object.field === "procurementStatus" ||
        object.field === "userStatus" ||
        object.field === "executiveChefStatus" ||
        object.field === "supplierStatus" ||
        object.field === "HODStatus" ||
        object.field === "HODApproval" ||
        object.field === "execChefApproval" ||
        object.field === "userApproval" ||
        object.field === "requesterSampleImage"
      ) {
        statusArray.push(object);
      } else if (
        object.field === "Details" ||
        object.field === "isActive" ||
        object.field === "markInactive" ||
        object.field === "editOrDeleteItem" ||
        object.field === "editItem"
      ) {
        actions.push(object);
      } else {
        rest.push(object);
      }
    });
    let newArray = [...actions, ...rest, ...statusArray];
    // Return the rearranged array of column definitions
    return newArray;
  } else return [];
}
